export default __webpack_public_path__ + "static/media/jsback.8216844c.svg";